import React from 'react';
import { CreditCardIcon } from 'lucide-react';
interface PaymentNoteProps {
  className?: string;
}
export function PaymentNote({
  className = ''
}: PaymentNoteProps) {
  return <p className={`flex items-start justify-center gap-2 text-left text-xs leading-relaxed text-muted sm:text-center ${className}`} data-id="element-455" data-mp="r2c1mlv2n32a">
      <CreditCardIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-456" data-mp="w2ghc9o5ntrg" />
      <span data-id="element-457" data-mp="1jqpy2x6ihrbq">
        Tenemos disponibles múltiples métodos de pago y puedes pagar en la moneda local de tu país.
        La conversión automática la ves en la próxima página, antes de confirmar.
      </span>
    </p>;
}